import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Twitter, Mail, ArrowUpRight } from 'lucide-react';
import { siteConfig } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Speaking', path: '/speaking' },
    { name: 'Ty the Mission', path: '/ty-the-mission' },
    { name: 'About', path: '/about' },
    { name: 'Book Tyrre', path: '/book' },
  ];

  const socialLinks = [
    { name: 'LinkedIn', icon: Linkedin, url: siteConfig.socialLinks.linkedin },
    { name: 'Instagram', icon: Instagram, url: siteConfig.socialLinks.instagram },
    { name: 'Twitter', icon: Twitter, url: siteConfig.socialLinks.twitter },
  ];

  return (
    <footer className="bg-[#0d0d0d] border-t border-[rgba(168,168,160,0.1)]">
      <div className="container-custom">
        {/* Main Footer Content */}
        <div className="py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
            {/* Brand Column */}
            <div className="md:col-span-5">
              <Link to="/" className="inline-block mb-6">
                <img 
                  src="https://customer-assets.emergentagent.com/job_1e5c107d-48e5-49a9-bc86-236f456dfd6e/artifacts/3hsl2ln5_Ty%20Logo2-03.png" 
                  alt={siteConfig.name}
                  className="w-auto invert brightness-100"
                  style={{ height: '120px' }}
                />
              </Link>
              <p className="text-[#a8a8a0] body-medium max-w-sm mb-6">
                Speaker. Entrepreneur. Mission Architect. Helping leaders integrate purpose into every role they carry.
              </p>
              <div className="gold-accent"></div>
            </div>

            {/* Navigation Column */}
            <div className="md:col-span-3">
              <h4 className="caption text-[#c9a86c] mb-6">Navigation</h4>
              <ul className="space-y-3">
                {navLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-[#a8a8a0] hover:text-[#f5f5f0] transition-colors body-medium inline-flex items-center gap-1 group"
                    >
                      {link.name}
                      <ArrowUpRight
                        size={14}
                        className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all"
                      />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Column */}
            <div className="md:col-span-4">
              <h4 className="caption text-[#c9a86c] mb-6">Get in Touch</h4>
              <a
                href={`mailto:${siteConfig.email}`}
                className="text-[#f5f5f0] hover:text-[#c9a86c] transition-colors body-medium inline-flex items-center gap-2 mb-6"
              >
                <Mail size={18} />
                {siteConfig.email}
              </a>
              
              <div className="flex gap-4 mt-6">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center border border-[rgba(168,168,160,0.2)] text-[#a8a8a0] hover:border-[#c9a86c] hover:text-[#c9a86c] hover:bg-[#c9a86c]/10 transition-all"
                    aria-label={social.name}
                  >
                    <social.icon size={18} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-[rgba(168,168,160,0.1)] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#6b6b65] text-sm">
            © {currentYear} {siteConfig.name}. All rights reserved.
          </p>
          <p className="text-[#6b6b65] text-sm">
            Alignment isn't a destination. It's a discipline.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;